import '../stylesheets/frontend/frontend.css.scss'

import { Application } from 'stimulus'
import { definitionsFromContext } from 'stimulus/webpack-helpers'

const application = Application.start()
const context = require.context('controllers', true, /_controller\.(js|ts)$/)
application.load(definitionsFromContext(context))
